import { useTranslation } from "react-i18next";

import FormContainer from "@/pages/Public/components/FormContainer";
import { noop } from "@/utils/noop";

import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Button } from "@/components/Button/Button";

interface CybersecurityPromptProps {
	handleStart: (answer: "yes") => void;
	isLoading: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formError?: any;
}

export default function CybersecurityPrompt({
	handleStart,
	isLoading,
	formError,
}: CybersecurityPromptProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.cybersecurity.${key}`);

	return (
		<FormContainer
			formContainerClassName="h-fit mt-16"
			formError={formError}
			handleSubmit={noop}
			hideActions={true}
			isLoading={isLoading}
			showLogo={false}
			submitButtonText={null}
			submitButtonType="button"
			title={ts("title")}
		>
			<p className="text-[14px] text-primary-gray-lighter mb-6">{ts("description")}</p>
			<div className="flex flex-wrap justify-center gap-4">
				<Button
					className="w-full sm:min-w-[120px] sm:w-auto"
					color={ButtonColor.ACTION}
					size={ButtonSize.ML}
					title={ts("yes")}
					type="button"
					onClick={() => handleStart("yes")}
				/>
			</div>
		</FormContainer>
	);
}
